import { BUSINESS } from "./data";

export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="relative overflow-hidden border-t border-white/10 bg-[#07080c]"
    >
      <div className="mx-auto flex max-w-7xl flex-wrap items-start justify-between gap-10 px-5 pt-16 sm:px-8">
        <div>
          <p className="font-display text-xl font-extrabold tracking-tight text-slate-50">
            H<span className="text-blue-400">.</span>ELEKTRONIK
          </p>
          <p className="mt-3 max-w-xs text-sm leading-relaxed text-slate-500">
            Meisterhafte Smartphone- & Tablet-Reparatur im Herzen von
            Gütersloh.
          </p>
        </div>
        <div className="text-sm text-slate-400">
          <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-slate-600">
            Kontakt
          </p>
          <p className="mt-3">{BUSINESS.street}</p>
          <p>
            {BUSINESS.city} · {BUSINESS.area}
          </p>
          <a
            href={BUSINESS.phoneHref}
            data-testid="footer-phone-link"
            className="mt-2 inline-block text-blue-400 transition-colors hover:text-blue-300"
          >
            Mobil {BUSINESS.phoneDisplay}
          </a>
        </div>
        <div className="text-sm text-slate-400">
          <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-slate-600">
            Rechtliches
          </p>
          <div className="mt-3 flex flex-col gap-2">
            <a href="#top" data-testid="footer-impressum-link" className="transition-colors hover:text-slate-200">
              Impressum
            </a>
            <a href="#top" data-testid="footer-datenschutz-link" className="transition-colors hover:text-slate-200">
              Datenschutz
            </a>
          </div>
        </div>
      </div>
      <div className="mx-auto flex max-w-7xl flex-wrap items-center justify-between gap-3 px-5 pt-12 sm:px-8">
        <p className="font-mono text-[10px] uppercase tracking-[0.2em] text-slate-600">
          © 2026 H.Elektronik — Gütersloh, Innenstadt
        </p>
        <p className="font-mono text-[10px] uppercase tracking-[0.2em] text-slate-600">
          Präzision statt Neukauf
        </p>
      </div>
      <div aria-hidden className="pointer-events-none select-none px-2 pb-2 pt-6">
        <p className="text-center font-display text-[15.5vw] font-extrabold leading-[0.85] tracking-tight text-white/[0.04]">
          H.ELEKTRONIK
        </p>
      </div>
    </footer>
  );
}
